import { createSlice } from '@reduxjs/toolkit'
import { getJwt, saveJwt, saveUser, tokenRefresh } from '../../utils/authentication'
import { logout } from '../async-thunks/auth/logout'
import { signIn } from '../async-thunks/auth/signIn'

const initialState = !!getJwt()

const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(signIn.fulfilled, (state, action) => {
                const tokens = action.payload
                saveJwt(tokens.access_token)
                tokenRefresh(tokens.refresh_token)
                saveUser(tokens)

                state = true
                return state
            })
            .addCase(logout.pending, (state) => {
                // clear local storage and global state regardless the success of the API call
                state = false
                return state
            })
            .addCase(logout.fulfilled, (state) => {
                state = false
                return state
            })
            .addCase(logout.rejected, (state) => {
                state = false
                return state
            })
    },
})

export const { actions: authActions } = authSlice
export const { reducer: authReducer } = authSlice
